module.exports = __webpack_public_path__ + "static/media/aircombat_ex3.5a93d559.gif";